import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "imageContainer" };
const _hoisted_2 = { class: "textContainer" };
import HeaderBlock from './elements/HeaderBlock.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'BuyWithConfidencePage',
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_v_img = _resolveComponent("v-img");
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(HeaderBlock, { title: "Buy with Confidence" }),
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_v_img, {
                        src: require('@/assets/bg/BuyWithConfidence.png'),
                        class: "main-image",
                        position: "top"
                    }, null, 8, ["src"])
                ]),
                _createElementVNode("div", _hoisted_2, [
                    _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "title" }, "Buy with confidence", -1)),
                    _createVNode(_component_v_img, {
                        class: "paymentMethods mb-4",
                        src: require('@/assets/payment-methods.png')
                    }, null, 8, ["src"]),
                    _cache[1] || (_cache[1] = _createElementVNode("p", { class: "paragraph" }, " Experience seamless transactions with our secure payment options. Your financial safety is our top priority. ", -1))
                ]),
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "footerText anchor-bottom" }, [
                    _createElementVNode("p", null, "We never share any information with your employer, or a third party without your consent.")
                ], -1))
            ]));
        };
    }
});
